// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { MainLayout as Orders__MainLayout } from "../Orders/MainLayout.js";
import { MatTabsModule } from "@angular/material/tabs";
import { CustomerRequestInclude as Orders__CustomerRequestInclude } from "../Orders/CustomerRequestInclude.js";
import { VendorOffersInclude as Orders__VendorOffersInclude } from "../Orders/VendorOffersInclude.js";
import { VendorOffersComparisonInclude as Orders__VendorOffersComparisonInclude } from "../Orders/VendorOffersComparisonInclude.js";
import { MatButtonModule } from "@angular/material/button";

interface Properties {
    request: This.CustomerRequest;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-VendorOffersProcess',
    templateUrl: './VendorOffersProcess.html',
    styleUrls: ['./VendorOffersProcess.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        Orders__MainLayout,
        MatTabsModule,
        Orders__CustomerRequestInclude,
        Orders__VendorOffersInclude,
        Orders__VendorOffersComparisonInclude,
        MatButtonModule
    ],
})
export class VendorOffersProcess extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.VendorOffersProcess';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    @Output()
    submit = new EventEmitter<This.CustomerRequest>();
    @Output()
    save = new EventEmitter<This.CustomerRequest>();
    output = {
        submit: async (data: This.CustomerRequest, followNextUserTask = true) => {
            data = (data as any)?.$clone ? (data as any).$clone() : data
            let result: any
            result = await (followNextUserTask ? Sys.Process.driveProcessAndFollowNextUserTask : Sys.Process.driveProcess)('submit', data)
            this.submit.emit(data)
            if (this.dialogData?.closeOnOutput === 'submit') { this.dialogRef?.close(data) }
            return result
        },
        save: async (data: This.CustomerRequest, followNextUserTask = true) => {
            data = (data as any)?.$clone ? (data as any).$clone() : data
            let result: any
            result = await (followNextUserTask ? Sys.Process.driveProcessAndFollowNextUserTask : Sys.Process.driveProcess)('save', data)
            this.save.emit(data)
            if (this.dialogData?.closeOnOutput === 'save') { this.dialogRef?.close(data) }
            return result
        },
    };
    $validators: Record<number, ValidationRules> = {

    };
    input_request = input(undefined, { alias: 'request' });
    var_request = proxySignal<This.CustomerRequest>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get request() { return component.var_request() },
                set request(value: This.CustomerRequest) { component.var_request.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            request: this.screen.request
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_request = this.dialogData?.data?.request ?? this.input_request() ?? (undefined)
            if (new_request !== undefined) this.screen.request = new_request

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async handler_ButtonBlock_25_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, $disabled }: { form: Sys.Types.Form, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    output.submit(screen.request)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_106_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, $disabled }: { form: Sys.Types.Form, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    output.save(screen.request)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            if (!screen.request.customerOffer) {
                // Do currency conversion for all offered items and quantities
                for (const vendorOffer of screen.request.vendorOffers) {
                    for (const item of vendorOffer.items) {
                        for (const quantity of item.quantities) {
                            quantity.unitPriceCustomerCcy = This.ExchangeRate.convert(quantity.unitPriceDiscounted, vendorOffer.currency, screen.request.currency)
                        }
                    }
                }

                screen.request.customerOffer = new This.CustomerOffer({
                    currency: screen.request.currency,
                    items: screen.request.items.map(item => {
                        const allQuantities = screen.request.vendorOffers.flatMap(offer =>
                            (offer.getItemForReqItem(item.id)?.quantities ?? [])
                                .filter(({ quantity, unitPrice }) => quantity && unitPrice)
                                .map(({ quantity }) => quantity)
                        )
                        const quantities = Array.from(new Set(allQuantities))

                        return new This.CustomerOfferItem({
                            requestItem: item,
                            quantities: quantities.map(quantity => {

                                const allOfferItems = screen.request.vendorOffers.flatMap(offer => offer.items.map(offerItem => ({ offer, offerItem })))
                                    .filter(({ offerItem }) => offerItem.requestItemId == item.id && offerItem.getQuantity(quantity))
                                    .sort((a, b) => a.offerItem.getQuantity(quantity)?.unitPriceCustomerCcy - b.offerItem.getQuantity(quantity)?.unitPriceCustomerCcy)
                                const bestVendorOfferQuantity = allOfferItems[0]?.offerItem.getQuantity(quantity)

                                return new This.CustomerOfferItemQuantity({
                                    quantity,
                                    bestVendorOfferQuantity,
                                })
                            })
                        })
                    })
                })

                let replyText = ''
                switch (screen.request.language.id) {
                    case 'de':
                        replyText += `
            <p>Anbei finden Sie unsere Offerte.</p>
            `
                        break
                    case 'en':
                        replyText += `
            <p>Please find attached our offer.</p>
            `
                        break
                    case 'fr':
                        replyText += `
            <p>Trouvez notre offre ci-joint.</p>
            `
                        break
                }
                screen.request.customerOffer.emailText = `<p>${screen.request.salutationForReply}</p>\n${replyText}\n${This.$Config.Company.emailSignature}`
            }

        }
    }
}
